import React from 'react';
import bgVideoBanners from '../../images/ourDNA/OurNewDNA/videoAcademy.mp4';

const VideoBannerAcademy = ({ children }) => {
  return (
    <div className="videobackground-containerBannerCademy">
      <video autoPlay loop muted playsInline className="banners-video">
        <source src={bgVideoBanners} type="video/mp4" />
        ...
      </video>
    </div>
  );
};

export default VideoBannerAcademy;
